import ScreenBarPartner from "./components/screen-bar-partner";
import Fireworks from "@fireworks-js/react";
import ScreenDonSection from "./components/screen-don-section";
import {useEffect} from "react";


// Palette de la maquette Gala Talpiot (hardcodée volontairement, cf. décision produit).
const TALPIOT = {
    deepBlue: "#0D3867",   // texte des cards + grand nombre + sous-titre
    gold: "#D2B171",       // bordure des cards + barre de progression
    cardBg: "#FBF1DC",     // fond crème des cards
    white: "#FFFFFF",
}

// CSS local au composant : @font-face + structure + animations.
// Scopé sous `.talpiot-screen` pour ne rien laisser fuir globalement.
// Polices réutilisées d'autres screens : Playfair Display SemiBold Italic
// (custom-bl-etudiants-v3) et Proxima Nova (fonts).
const SCREEN_CSS = `
@font-face{
    font-family:"Talpiot-Playfair";
    src:url("/campagne/screen/custom-bl-etudiants-v3/PlayfairDisplay-SemiBoldItalic.ttf");
    font-style:italic;
    font-weight:600;
    font-display:swap;
}
@font-face{
    font-family:"Talpiot-Proxima";
    src:url("/campagne/fonts/proximanova-regular.woff2") format("woff2"),
        url("/campagne/fonts/proxima-nova-regular.otf") format("opentype");
    font-weight:500;
    font-style:normal;
    font-display:swap;
}

.talpiot-screen, .talpiot-screen *{
    -webkit-touch-callout:none;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    box-sizing:border-box;
}

.talpiot-screen-background{
    position:absolute;
    top:0;bottom:0;left:0;right:0;
    background-color:#0a1f3d;
}

.talpiot-screen-content{
    position:absolute;
    top:0;bottom:0;left:0;right:0;
}

.talpiot-don-card{
    height:16vh;
    min-width:23vw;
    max-width:23vw;
    border-radius:18px;
    overflow:hidden;
    position:relative;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    background-color:${TALPIOT.cardBg};
    border:10px solid ${TALPIOT.gold};
    box-shadow:0 6px 24px rgba(0,0,0,.25);
    animation-duration:2s;
    animation-fill-mode:both;
}

@keyframes talpiotDonFadeIn{
    from{ left:3vw; opacity:0; }
    to{ left:0vw; opacity:1; }
}
.talpiot-don-fade-in{ animation-name:talpiotDonFadeIn; }
.talpiot-don-fade-out{ display:none; }
`;


export default function CustomTalpiot({context, loading, campagneData})
{
    const screenOptions = campagneData?.screenOptions || {}

    useEffect(() => {
        document.body.style.overflow = "hidden";
        document.body.style.cursor = "none";
    }, []);


    if(loading)
    {
        return (
            <div className="talpiot-screen" style={{aspectRatio: "16/9", position: "relative"}}>
                <style dangerouslySetInnerHTML={{__html: SCREEN_CSS}}/>
                <div className={"talpiot-screen-background"}/>
            </div>
        )
    }


    return (
        <div className="talpiot-screen" style={{aspectRatio: "16/9", position: "relative"}}>
            <style dangerouslySetInnerHTML={{__html: SCREEN_CSS}}/>

            <div className={"talpiot-screen-background"}>
                <img src={"/campagne/screen/custom-talpiot/Fond.png"}
                     style={{height: "100vh", width: "100vw", objectFit: "cover"}} alt=""/>
            </div>

            <div className={"talpiot-screen-content"}>
                <div style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                }}>


                    <div style={{marginTop: "20vh", width: "100%"}}>
                        <ScreenDonSection context={context} campagneData={campagneData} colors={TALPIOT}/>
                    </div>


                    <div style={{position:"absolute",top:"40vh", width: "100%"}}>
                        <ScreenBarPartner context={context} campagneData={campagneData} colors={TALPIOT} mini={screenOptions.barMini}/>
                    </div>


                    {screenOptions.forceCelebration && (
                        <Fireworks
                            autostart
                            options={{intensity: 30, particles: 100, traceLength: 1, opacity: 0.2}}
                            style={{
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                position: 'fixed',
                                background: 'transparent'
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
